module.exports = __webpack_public_path__ + "img/atr.4b44ff97.png";